import { render, staticRenderFns } from "./SocialMenu.vue?vue&type=template&id=59ddbe8c&scoped=true&"
import script from "./SocialMenu.vue?vue&type=script&lang=js&"
export * from "./SocialMenu.vue?vue&type=script&lang=js&"
import style0 from "./SocialMenu.vue?vue&type=style&index=0&id=59ddbe8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddbe8c",
  null
  
)

export default component.exports